import { getNaaviCrud } from "./naaviClient";
import type { CollectionResponse } from "./types";

export interface ClassSearchPayload {
  tenantIds?: string[];
  date?: string;
  includeOnline?: boolean | null;
  includeInPerson?: boolean | null;
  latitude?: number | null;
  longitude?: number | null;
  radiusKm?: number | null;
  therapy?: string | null;
  therapyType?: string | null;
  maxResults?: number | null;
  customerId?: number | null;
}

export interface ClassTherapist {
  id?: number;
  name?: string;
  avatarUrl?: string;
}

export interface ClassBooking {
  id: number;
  start: string;
  end: string;
  startLocalDisplay?: string;
  endLocalDisplay?: string;
  resourceId: number;
  resourceName?: string;
  participantsIn?: number;
  maxParticipants?: number;
  durationMinutes?: number;
}

export interface ClassPrice {
  grossAmount?: number;
  netAmount?: number;
  taxes?: number;
  grossAmountStr?: string;
  netAmountStr?: string;
  taxesStr?: string;
  currencyCode?: string;
  locale?: string;
}

export interface ClassSummary {
  tenantId: string;
  tenantXId?: string;
  tenantName: string;
  tenantLogo?: string;
  tenantUrl?: string;
  classId: number;
  bookingTypeId: number;
  title: string;
  description?: string;
  extendedDescription?: string;
  imageUrl?: string;
  start: string;
  end: string;
  startLocalDisplay?: string;
  durationMinutes: number;
  online: boolean;
  locationName?: string;
  fullAddress?: string;
  latitude?: number;
  longitude?: number;
  participantsIn: number;
  maxParticipants?: number;
  price?: ClassPrice;
  therapist: ClassTherapist;
  distanceKm: number;
  allowCreateBookByPlace: boolean;
  bookings: ClassBooking[];
  hasBooking?: boolean;
}

export type ClassesResponse = CollectionResponse<ClassSummary>;
const crud = getNaaviCrud();

export function searchClasses(payload: ClassSearchPayload) {
  return crud.httpPost(
    "/api/internal/classes",
    payload,
  ) as Promise<ClassesResponse>;
}

export function getClassDetail(
  tenantId: string,
  classId: number,
  dateIso?: string | null,
) {
  const query = dateIso ? `?date=${encodeURIComponent(dateIso)}` : "";
  return crud.httpGet(
    `/api/internal/classes/${tenantId}/${classId}${query}`,
  ) as Promise<ClassSummary>;
}

export function getDoctorClasses(
  tenantId: string,
  doctorId: number,
  dateIso?: string | null,
) {
  const query = dateIso ? `?date=${encodeURIComponent(dateIso)}` : "";
  return crud.httpGet(
    `/api/internal/classes/${tenantId}/doctor/${doctorId}${query}`,
  ) as Promise<ClassesResponse>;
}
